<template lang="pug">
    v-toolbar( :color='color' dark dense flat )
        v-toolbar-title( class="body-2 text-uppercase" ) {{ title }} 
            small( class="ml-2 grey--text text--lighten-2" ) {{ subtitle }}
        v-spacer
        v-toolbar-items
            slot( name="items" )
</template>

<script>
    export default {
        props: {

            /**
             * 
             */
            color: {
                type: String,
                default: 'primary',
            },
            
            /**
             * 
             */
            subtitle: String,

            /**
             * 
             */
            title: String,
        }
    }
</script>
